import * as React from 'react';
import { cn } from '../lib/utils';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../primitives/card';

interface PanelProps extends React.ComponentPropsWithoutRef<'div'> {
  title?: string;
  description?: string;
  actions?: React.ReactNode;
  header?: React.ReactNode;
  headerClassName?: string;
  contentClassName?: string;
  children?: React.ReactNode;
}

export function Panel({
  title,
  description,
  actions,
  header,
  className,
  headerClassName,
  contentClassName,
  children,
  ...props
}: PanelProps) {
  return (
    <Card className={className} {...props}>
      {header ? (
        <CardHeader className={headerClassName}>{header}</CardHeader>
      ) : title || description || actions ? (
        <CardHeader
          className={cn(
            'flex flex-col gap-4 md:flex-row md:items-start md:justify-between',
            headerClassName
          )}
        >
          <div className="space-y-1">
            {title ? <CardTitle>{title}</CardTitle> : null}
            {description ? <CardDescription>{description}</CardDescription> : null}
          </div>
          {actions ? <div className="flex shrink-0 flex-wrap gap-3">{actions}</div> : null}
        </CardHeader>
      ) : null}
      <CardContent
        className={cn(!(title || description || actions) && 'p-5', contentClassName)}
      >
        {children}
      </CardContent>
    </Card>
  );
}
